import React, { useState, useEffect } from "react";
import { useLoginMutation } from "../features/auth/authApi";
import { useSelector } from "react-redux";
import { selectIsAuthed } from "../features/auth/authSlice";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [login, { isLoading, error }] = useLoginMutation();
  const authed = useSelector(selectIsAuthed);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";

  useEffect(() => {
    if (authed) navigate(from, { replace: true });
  }, [authed, from, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    await login({ email, password });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader>
          <h2 className="text-2xl font-semibold text-center">Sign in</h2>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-4">
            <Input
              // type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Button className="w-full mb-4" disabled={isLoading} type="submit">
              {isLoading ? "Signing in…" : "Sign in"}
            </Button>
            {error && (
              <p className="text-sm text-destructive text-center ">
                Login failed
              </p>
            )}
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
